<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div
              class="panel content-panel content-panel-large intro-panel pad-medium"
            >
              <h1>Profile</h1>
              <form action="javascript:void(0);">
                <div class="row">
                  <div class="col-md-6">
                    <label>First name</label>
                    <input
                      ref="firstname"
                      type="text"
                      v-model="firstName"
                      class="form-control"
                      placeholder="First name"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Last name</label>
                    <input
                      type="text"
                      v-model="lastName"
                      class="form-control"
                      placeholder="Last name"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Country</label>
                    <multiselect
                      v-model="countryObject"
                      :options="countries"
                      placeholder="Select country"
                      deselectLabel
                      :multiple="false"
                      label="name"
                      :close-on-select="true"
                      :clear-on-select="true"
                      track-by="cca2"
                    ></multiselect>
                  </div>
                  <div class="col-md-6">
                    <label>Gender</label>
                    <multiselect
                      v-model="gender"
                      :options="genders"
                      :multiple="false"
                      placeholder="Select gender"
                      :close-on-select="true"
                      :clear-on-select="true"
                    ></multiselect>
                  </div>
                  <div class="col-md-6">
                    <label>Age</label>
                    <input
                      type="number"
                      v-model="age"
                      class="form-control"
                      ref="number"
                      placeholder="Age"
                    />
                  </div>
                  <div class="col-md-6"></div>
                  <div class="col-md-6">
                    <label>Industry</label>
                    <multiselect
                      v-model="industryObject"
                      :options="industries"
                      :multiple="false"
                      placeholder="Select industry"
                      label="name"
                      :close-on-select="true"
                      :clear-on-select="true"
                      track-by="id"
                      @input="clearSubIndustry()"
                    ></multiselect>
                  </div>
                  <div class="col-md-6">
                    <div :class="{ disabled: !industryObject }">
                      <label>Subindustry</label>
                      <multiselect
                        v-model="subIndustryObject"
                        :options="filteredsubIndustries"
                        :multiple="false"
                        placeholder="Select subindustry"
                        label="name"
                        :close-on-select="true"
                        :clear-on-select="true"
                        track-by="id"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <hr />
                  </div>
                  <div class="col-md-12 public-container">
                    <div>
                      <button
                        class="toggle"
                        v-bind:class="{ active: publicProfile }"
                        v-on:click="publicProfile = !publicProfile"
                      >
                        <span class="label">Public personality report</span>
                        <span class="switcher"> </span>
                      </button>
                    </div>
                    <div v-if="publicProfile" class="warning">
                      With public profile <strong>enabled</strong>, anyone with
                      the shareable link can view your personality report.
                    </div>
                    <div v-if="publicProfile" class="copy-wrap">
                      <span>Share url: </span>
                      <div class="profile-url">{{ profileUrl }}</div>
                      <button
                        type="button"
                        class="btn btn-tertiary btn-sm"
                        title="Copy to clipboard"
                        v-tippy
                        @click="copyProfileUrl"
                      >
                        <font-awesome-icon icon="copy" />
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 text-right">
                    <router-link to="/" class="btn btn-tertiary"
                      >Cancel</router-link
                    >
                    <button
                      type="submit"
                      @click="updateAccount"
                      class="btn btn-primary btn-loader"
                      :class="{ active: loading, success: success }"
                    >
                      <span>Save and continue</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-4">
            <div
              v-if="!getUser.emailVerified"
              class="panel content-panel content-panel-large intro-panel pad-medium"
            >
              <h3>Verify account</h3>
              <p v-if="!verifyMessageSent">
                Verify your account by verifying your email address.
              </p>
              <p v-if="verifyMessageSent">
                Check your email for a verification email and follow the
                verification link.
              </p>
              <button
                type="submit"
                @click="sendVerifyEmail"
                v-if="!verifyMessageSent"
                class="btn btn-tertiary btn-md btn-loader"
                :class="{ active: loading }"
              >
                <span>Send verification email</span>
              </button>
              <div class="blue" v-if="this.verifyMessageSent"><strong>Verification email sent!</strong></div>
            </div>

            <div
              v-if="user.providerData[0].providerId === 'password'"
              class="panel content-panel content-panel-large intro-panel pad-medium"
            >
              <h3>Change password</h3>
              <form action="javascript:void(0);">
                <input
                  style="margin-bottom: 10px"
                  type="password"
                  v-model="currentPassword"
                  class="form-control"
                  ref="currentPassword"
                  placeholder="Current password"
                />
                <input
                  style="margin-bottom: 10px"
                  type="password"
                  v-model="newPassword"
                  class="form-control"
                  ref="newPassword"
                  placeholder="New password"
                />
                <input
                  type="password"
                  v-model="newPasswordRetype"
                  class="form-control"
                  ref="newPasswordRetype"
                  placeholder="Re-type new password"
                />
                <button
                  type="submit"
                  @click="changePassword"
                  class="btn btn-tertiary btn-md btn-loader"
                  :class="{ active: loading }"
                >
                  <span>Change password</span>
                </button>
              </form>
            </div>
            <div
              class="panel content-panel content-panel-large intro-panel pad-medium"
            >
              <h3>Remove account</h3>
              <p>
                By removing your account you lose all the data.
                <strong>This action can't be reversed</strong>.
              </p>
              <form action="javascript:void(0);">
                <input
                  type="password"
                  v-model="password"
                  class="form-control"
                  ref="password"
                  placeholder="Current password"
                  v-if="user.providerData[0].providerId === 'password'"
                />
                <button
                  type="submit"
                  @click="reauthenticateAndRemoveAccount"
                  class="btn btn-tertiary btn-md btn-warning btn-loader"
                  :class="{ active: loading }"
                >
                  <span>Remove account</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { db } from "../main.js";

var _ = require("lodash");

import { countries, industries, subIndustries } from "@/assets/static.js";
import { mapState } from "vuex";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      firstName: "",
      lastName: "",
      countries: countries,
      industries: industries,
      subIndustries: subIndustries,
      country: null,
      countryObject: null,
      industry: null,
      industryObject: null,
      gender: null,
      genders: ["Male", "Female", "Other"],
      publicProfile: null,
      subIndustry: null,
      subIndustryObject: {
        code: "notspecified",
        id: "1",
        name: "Not specified"
      },
      age: null,
      verifyMessageSent: false,
      currentPassword: null,
      newPassword: null,
      newPasswordRetype: null,
      password: null,
      loading: false,
      error: false,
      profileUrl: null,
      errorMessage: "",
      success: false
    };
  },
  mounted() {
    if (this.getUserData.firstName) {
      this.firstName = this.getUserData.firstName;
    }

    if (this.getUserData.lastName) {
      this.lastName = this.getUserData.lastName;
    }

    if (this.getUserData.gender) {
      this.gender = this.getUserData.gender;
    }

    if (this.getUserData.age) {
      this.age = this.getUserData.age;
    }

    if (this.getUserData.country) {
      this.country = this.getUserData.country;
      this.countryObject = countries.find(({ cca2 }) => cca2 === this.country);
    }

    if (this.getUserData.public) {
      this.publicProfile = this.getUserData.public;
    }

    if (this.getUserData.industry) {
      this.industry = this.getUserData.industry;
      this.industryObject = industries.find(({ id }) => id === this.industry);
    }

    if (this.getUserData.subIndustry) {
      this.subIndustry = this.getUserData.subIndustry;
      this.subIndustryObject = subIndustries.find(
        ({ id }) => id === this.subIndustry
      );
    }

    this.profileUrl = "https://app.traitstack.com/report/#" + this.user.uid;
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    ...mapState(["friends"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    getFriends() {
      return this.friends ? this.friends : "";
    },
    filteredsubIndustries() {
      if (this.industryObject) {
        if (this.industryObject.id == 1) {
          return [{ code: "notspecified", id: "1", name: "Not specified" }];
        } else {
          return _.orderBy(
            _.filter(_.orderBy(this.subIndustries, "id", "asc"), {
              parent_id: this.industryObject.id
            }),
            ["id"],
            ["asc"]
          );
        }
      } else {
        return [{ code: "notspecified", id: "1", name: "Not specified" }];
      }
    }
  },
  methods: {
    resetErrorState() {
      this.loading = false;
      this.success = false;
      this.error = false;
    },
    clearSubIndustry() {
      this.subIndustry = null;
    },
    copyProfileUrl() {
      this.$copyText(this.profileUrl).then(
        () => {
          this.$successMessage("Profile URL copied to clipboard.");
        },
        () => {
          this.$errorMessage("Unable to copy Profile URL");
        }
      );
    },
    changePassword() {
      if (!this.newPassword || !this.newPasswordRetype) {
        this.$errorMessage("Please fill all the required fields");
        return false;
      }

      if (this.newPassword !== this.newPasswordRetype) {
        this.$errorMessage("Passwords do not match");
        return false;
      }

      if (this.loading) {
        return false;
      }
      this.loading = true;

      var user = firebase.auth().currentUser;

      var credential = firebase.auth.EmailAuthProvider.credential(
        this.user.email,
        this.currentPassword
      );

      this.user
        .reauthenticateWithCredential(credential)
        .then(() => {
          user
            .updatePassword(this.newPassword)
            .then(() => {
              this.newPassword = null;
              this.newPasswordRetype = null;
              this.currentPassword = null;
              this.loading = false;
              this.$successMessage("Password updated succesfully.");
            })
            .catch(error => {
              this.resetErrorState();
              this.$errorMessage(error.message);
            });
        })
        .catch(error => {
          this.resetErrorState();
          this.$errorMessage(error.message);
        });
    },
    removeAccount: function() {
      var user = firebase.auth().currentUser;
      user
        .delete()
        .then(() => {
          this.$signOut();
        })
        .catch(error => {
          this.resetErrorState();
          this.$errorMessage(error.message);
        });
    },

    reauthenticateAndRemoveAccount: function() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      if (this.user.providerData[0].providerId === "google.com") {
        firebase
          .auth()
          .currentUser.reauthenticateWithPopup(
            new firebase.auth.GoogleAuthProvider()
          )
          .then(() => {
            this.removeAccount();
          })
          .catch(error => {
            this.resetErrorState();
            this.$errorMessage(error.message);
          });
      } else if (this.user.providerData[0].providerId === "facebook.com") {
        firebase
          .auth()
          .currentUser.reauthenticateWithPopup(
            new firebase.auth.FacebookAuthProvider()
          )
          .then(() => {
            this.removeAccount();
          })
          .catch(error => {
            this.resetErrorState();
            this.$errorMessage(error.message);
          });
      } else {
        if (!this.password) {
          this.resetErrorState();
          this.$errorMessage("Please check your password");
          return;
        }
        var credential = firebase.auth.EmailAuthProvider.credential(
          this.user.email,
          this.password
        );
        this.user
          .reauthenticateWithCredential(credential)
          .then(() => {
            this.removeAccount();
          })
          .catch(error => {
            this.resetErrorState();
            this.$errorMessage(error.message);
          });
      }
    },
    sendVerifyEmail: function() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      let sendEmailVerificationEmail = firebase
        .functions()
        .httpsCallable("sendEmailVerificationEmail");

      sendEmailVerificationEmail()
        .then(() => {
          this.loading = false;
          this.verifyMessageSent = true;
        })
        .catch(error => {
          this.resetErrorState();
          this.$errorMessage(error.message);
        });
    },
    updateAccount: function() {
      if (this.loading) {
        return false;
      }

      const userData = this.getUser;
      const uid = userData.uid;
      let that = this;

      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        gender: this.gender,
        age: this.age,
        public: this.publicProfile
      };

      // If country populated
      if (this.countryObject) {
        data.country = this.countryObject.cca2;
      } else {
        data.country = null;
      }

      // If industry populated
      if (this.industryObject) {
        data.industry = this.industryObject.id;
      } else {
        data.industry = null;
      }

      // If subindustry populated
      if (this.subIndustryObject) {
        data.subIndustry = this.subIndustryObject.id;
      } else {
        data.subIndustry = null;
      }

      if (uid) {
        this.loading = true;

        var batch = db.batch();

        // Update user details
        var userRef = db.collection("users").doc(uid);
        batch.update(userRef, data);

        // Update shared name
        var userSharedRef = db
          .collection("users")
          .doc(uid)
          .collection("shared")
          .doc(uid);

        batch.update(userSharedRef, {
          firstName: this.firstName,
          lastName: this.lastName
        });

        // Commit the batch
        batch
          .commit()
          .then(() => {
            this.loading = false;
            this.success = true;
            this.error = false;
            setTimeout(() => {
              that.$router.replace({ path: "/" });
            }, 500);
          })
          .catch(err => {
            this.$toast.open({
              message: err.message
            });
            this.loading = false;
            this.success = true;
            this.error = false;
            setTimeout(() => {
              this.$router.replace({ path: "/" });
            }, 500);
          });
      }
    }
  }
};
</script>
